import React, { useEffect, useRef, useState } from "react";
import "../../modal.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MessageType } from "../../constants";
import { formateDateTime, numDifferentiation } from "../../utils";

export function TermPlanDetails({ message, ViewPlanDetails, contactSupport, mainMenu, content, selectOption, scrollToBottom}) {
    const [viewMore, setViewMore] = useState(false)
    useEffect(() => {
        if (content.choices && content.choices.length > 2 && !message.selected) {
            setViewMore(true)
        }
    })
    const [count, setCount] = useState(-1);
    useEffect(() => {
        console.log(count)
        if (content.type  && message.selected) {
            setCount(9999)
        }
        else if (content.choices && content.choices.length > count ) {

            const interval = setInterval(() => {
                setCount((count)=> count + 1);
                scrollToBottom()
            }, 700);
            // scrollToBottom()
            return () => clearInterval(interval);
        }
    }, [count, message.displayAllOptions, viewMore]);
    return (
        <div class="product-info"> 
        {content && content.choices?.map((item, index)=>
        <>{index <= count ?
                   <div class={`card hidden ${index + 1 <= count ? 'show' : null} `} onClick={()=> selectOption(item, content.type, message.messageId)}>
                    <div class="prdcard" style={{ animation: 'fadeIn .3s' }}>
                        <div class="prd-logo">
                            <span><img className="plan-logo" src={item.logo}></img></span>
                            <span class="plan-name">{item.planShortName}</span>
                        </div>
                        <div class="premium">₹{item.monthlyTotalPremium.toLocaleString()} <i class="icon-arrow"></i></div>
                    </div>
                       <ul class="prd-info">
                           <li>
                            <span>Life Cover</span>
                           <span class="prd-detail">{numDifferentiation(item.SumAssured)}</span>
                            </li>
                           <li>
                            <span>Cover till age</span>
                           <span class="prd-detail">{item.newCoverageUpto} Years</span>
                            </li>
                           <li>
                            <span>Claim Settlement</span>
                           <span class="prd-detail">{item.Claims_Settled}%</span>
                            </li>
                       </ul>
                   </div> 
                   :null}
                   </>
        )}
                   
                  
                      
               </div>
    );
}


export function TermPlanDetailsCustomer({ message, ViewPlanDetails, contactSupport, mainMenu, content, selectOption }) {
    const [maxHeight, setMaxHeight] = useState("")
    const [featureHeight, setFeatureHeight] = useState("")
    const settings = {
        adaptiveHeight: false,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        className: "plan-differences-slider"
    };
    const ref = useRef(null)
    useEffect(() => {
        let div = document.querySelectorAll('.plan-info');
        let divHeight = []
        for (let element of div) {
            divHeight.push(element.offsetHeight)
        }
        setMaxHeight(Math.max(...divHeight))
        let feature = document.querySelectorAll('.sp-annouce');
        let featureHeight = []
        for (let element of feature) {
            featureHeight.push(element.offsetHeight)
        }
        setFeatureHeight(Math.max(...featureHeight))

    })
    return (
        <div className="grop_message">
            <div className="message">

           
        <div class="product-info"> 
        
                   <div class="card" >
                    <div class="prdcard">
                        <div class="prd-logo">
                            <span className="lgwrap"><img className="plan-logo" src={content.logo}></img></span>
                            <span class="plan-name">{content.planShortName}</span>
                        </div>
                        <div class="premium">₹{content.monthlyTotalPremium.toLocaleString()} <i class="icon-arrow"></i></div>
                    </div>
                       <ul class="prd-info">
                           <li>
                            <span>Life Cover</span>
                           <span class="prd-detail">{numDifferentiation(content.SumAssured)}</span>
                            </li>
                           <li>
                            <span>Cover till age</span>
                           <span class="prd-detail">{content.newCoverageUpto} Years</span>
                            </li>
                           <li>
                            <span>Claim Settlement</span>
                           <span class="prd-detail">{content.Claims_Settled}%</span>
                            </li>
                       </ul>
                   </div> 
           
                  
                   </div>
        </div>  
               </div>
    );
}

